import client from "../libs/HttpClient";

class TutorialVideoServices {
  static viewTutorialVideo(params) {
    return client.get(`/videotutorial`, { params });
  }
}

export { TutorialVideoServices };
